import React, { useMemo } from 'react'
import * as style from './index.module.css'

interface Props {
  /** リンクテキスト */
  readonly text: string
  /** テキストの色 */
  readonly textColor: 'black' | 'white'
  /** 遷移先 */
  readonly to: string
  /** アイコン */
  readonly icon?: React.ReactNode
}

/**
 * @file header、footerのナビゲーションテキスト
 *
 * @param @see {@link Props}
 */
export const ATagText = ({
  text,
  textColor,
  to,
  icon,
}: Props): React.JSX.Element => {
  const isHeader = useMemo(
    () => (textColor === 'black' ? style.black : style.white),
    [textColor],
  )

  return (
    <a
      className={style.textContainer}
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`リンク: ${text}`}
    >
      {/* hover前のテキスト */}
      <span className={`${isHeader} ${style.text} ${style.current}`}>
        {icon && <span className={style.icon}>{icon}</span>}
        {text}
      </span>
      {/* hover後のテキスト */}
      <span className={`${isHeader} ${style.text} ${style.afterHover}`}>
        {icon && <span className={style.icon}>{icon}</span>}
        {text}
      </span>
    </a>
  )
}
